<template>
    <button @click="goBack" class="go-back">
        <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="7.28906" width="10.3084" height="1.49941" rx="0.749705" transform="rotate(-45 0 7.28906)"
                  fill="#534340"/>
            <rect x="1.06055" y="6.22852" width="10.3084" height="1.49941" rx="0.749705"
                  transform="rotate(45 1.06055 6.22852)" fill="#534340"/>
            <rect x="0.449219" y="6.57422" width="20.5506" height="1.49941" rx="0.749705" fill="#534340"/>
        </svg>
        <span>Назад</span>
    </button>
</template>

<script>
export default {
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="scss" scoped>
.go-back {
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 21px;
    line-height: 26px;
    color: #534340;
    margin-bottom: 50px;
    @media (max-width: 767px) {
        display: none;
    }
}
</style>